import React, { useEffect, useState } from 'react';
import Footer from '../layouts/footer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Profile() {
  const navigate = useNavigate();
  const [data, setData] = useState({});

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const payload = { token: localStorage.getItem('token') };
      axios.post('employee/profile', payload).then((response) => {
        const resData = response.data.data;
        setData(resData.employee || {});
      });
    } else {
      window.location.replace('login');
    }
  }, []);

  const edit = () => {
    navigate('/profile-edit', { state: { data: data } });
  };
  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <>
      <div className="profile-hero py-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-auto">
              <div className="avatar-wrapper">
                <img src={data.image || '/assets/images/default-avatar.png'} alt="avatar" className="avatar-img" />
              </div>
            </div>
            <div className="col">
              <h4 className="mb-1 text-white">{data.f_name || 'Employee'}</h4>
              <div className="small text-white mb-2">{data.designation}</div>
              <div>
                <button className="btn btn-light btn-sm me-2" onClick={edit}>
                  <i className="fas fa-edit me-1"></i> Edit Profile
                </button>
                <button className="btn btn-outline-light btn-sm" onClick={logout}>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container root py-4">
        <div className="row g-3">
          <div className="col-12 col-md-8">
            <div className="card card-modern">
              <div className="card-body">
                <h6 className="mb-3">Profile Details</h6>
                <div className="row">
                  <div className="col-6 mb-3">
                    <div className="text-muted small">Email</div>
                    <div className="fw-semibold">{data.email || '—'}</div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="text-muted small">Employee ID</div>
                    <div className="fw-semibold">{data.emp_id || '—'}</div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="text-muted small">Department</div>
                    <div className="fw-semibold">{data.department || '—'}</div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="text-muted small">Manager</div>
                    <div className="fw-semibold">{data.manager || 'N/A'}</div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="text-muted small">Date of Joining</div>
                    <div className="fw-semibold">{data.join_date || '—'}</div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="text-muted small">Employee Type</div>
                    <div className="fw-semibold">{data.emp_type || '—'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="card card-modern">
              <div className="card-body text-center">
                <h6 className="mb-3">Quick Actions</h6>
                <button className="btn btn-brand w-100 mb-2" onClick={() => navigate('/attendance')}>
                  Mark Attendance
                </button>
                <button className="btn btn-outline-secondary w-100" onClick={() => navigate('/leave')}>
                  Apply Leave
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
